
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { cleanLoginInfo, getUserId, getUserName } from "../utils/auth";
import { getRole } from "../utils/permission";
import enumValue from "../utils/enum";
import { Grid, User, OfficeBuilding, UserFilled, Histogram, LocationFilled, Scissor, SwitchButton } from '@element-plus/icons-vue';
import { ElSpace } from "element-plus";

export default defineComponent({
  name: "Layout",
  components: {
    Grid,
    User,
    OfficeBuilding,
    UserFilled,
    Histogram,
    LocationFilled,
    Scissor,
    SwitchButton,
    ElSpace
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    
    // 响应式状态
    const userShow = ref(false);
    const appStatus = ref(false);
    const userStatus = ref(false);
    const manufacturerStatus = ref(false);
    
    // 计算属性
    const activeIndex = computed(() => route.path);
    
    // 方法
    const checkPermission = (): void => {
      const role = getRole(getUserId());
      if (role !== enumValue.permissionAdmin) {
        userShow.value = false;
      } else {
        userShow.value = true;
      }
    };
    
    const logoutHandle = (): void => {
      cleanLoginInfo();
      router.push({ name: "login" });
    };
    
    const getName = (): string => {
      return getUserName();
    };
    
    const handleSelect = (key: string): void => {
      // 可以在这里添加额外的导航逻辑
      console.log('Selected:', key);
    };
    
    const handleOpen = (key: string, keyPath: string[]): void => {
      console.log(key, keyPath);
    };
    
    const handleClose = (key: string, keyPath: string[]): void => {
      console.log(key, keyPath);
    };
    
    // 生命周期
    onMounted(() => {
      checkPermission();
    });
    
    return {
      userShow,
      appStatus,
      userStatus,
      manufacturerStatus,
      activeIndex,
      logoutHandle,
      getName,
      handleSelect,
      handleOpen,
      handleClose
    };
  }
});
